import styled from 'styled-components';

export const Passenger = styled.div`
  text-align: left;
  display: flex;
  flex-direction: column;
  gap: 12px;
  margin-top: 20px;
  padding: 24px;
  border: 1px solid #e6eaf2;
  border-radius: 18px;
  background: #fff;
  box-shadow: 0 12px 30px rgba(15, 23, 42, 0.06);
  label {
    text-transform: capitalize;
    font-weight: 600;
    color: #0f172a;
  }
  @media (max-width: 576px) {
    padding: 18px;
    margin-bottom: 20px;
  }
`;
export const PassengerName = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(220px, 1fr));
  gap: 16px;
`;
export const Select = styled.select`
  padding: 0.575rem 0.75rem;
  border: 1px solid #d7deea;
  border-radius: 12px;
  background: #f8fafc;
  min-width: 110px;
  outline: none;
  &&:focus-visible {
    border-color: #2563eb;
    box-shadow: 0 0 0 3px rgb(37 99 235 / 20%);
  }
`;
export const Nid = styled.div`
  text-align: left;
  display: flex;
  flex-direction: column;
  gap: 12px;
  margin-top: 20px;
  padding: 24px;
  border: 1px solid #e6eaf2;
  border-radius: 18px;
  background: #fff;
  box-shadow: 0 12px 30px rgba(15, 23, 42, 0.06);
  label {
    text-transform: capitalize;
    font-weight: 600;
    color: #0f172a;
  }
  @media (max-width: 576px) {
    padding: 18px;
  }
`;
export const UserContactWrapper = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(220px, 1fr));
  gap: 16px;
  align-items: center;
  .input-group {
    width: 100%;
    margin-bottom: 0;
  }
`;
export const FirstNameAndNid = styled.div`
  display: flex;
  gap: 12px;
  width: 100%;
  align-items: center;
  flex-wrap: wrap;
  & > ${Select} {
    flex: 0 0 130px;
  }
  .input-group {
    flex: 1 1 260px;
    margin-bottom: 0;
  }
`;
